import axios from 'axios';
import Api from '../library/Api.js';
import base from './ServicoBase.js';

export default {

        getIndexCliente() {
                return Api.Call("dashboard", "get", {});
        },
        getIndexAdmin() {
                return Api.Call("dashboard_admin", "get", {});
        },


}